import { useTranslation } from 'react-i18next';

export const RecaptchaText = () => {
  const { t } = useTranslation();

  return (
    <div className="text-text-subtlest text-sm my-2 px-5 pb-4">
      {t('RECAPTCHA_PROTECTED')}
      <a className="underline font-semibold text-text-subtlest mx-1" href="https://policies.google.com/privacy">
        {t('RECAPTCHA_POLICY')}
      </a>
      {t('RECAPTCHA_AND')}
      <a className="underline font-semibold text-text-subtlest mx-1" href="https://policies.google.com/terms">
        {t('RECAPTCHA_TERMS')}
      </a>
      {t('RECAPTCHA_APPLY')}
    </div>
  );
};
